import { render } from "./autocompleteWhitelistedGroups.vue?vue&type=template&id=4e4c7b0f"
import script from "./autocompleteWhitelistedGroups.vue?vue&type=script&lang=js"
export * from "./autocompleteWhitelistedGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__